import { Card, CardContent } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';
import { Button } from '@/components/ui/Button';
import type { QueueStats } from '@/types/admin.types';
import { usePauseQueue, useResumeQueue } from '@/hooks/useAdminAutomations';
import { Pause, Play } from 'lucide-react';
import { formatNumber } from '@/utils/formatters';

interface QueueStatusCardProps {
  queue: QueueStats;
}

export function QueueStatusCard({ queue }: QueueStatusCardProps) {
  const pause = usePauseQueue();
  const resume = useResumeQueue();

  return (
    <Card>
      <CardContent>
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-sm font-semibold text-neutral-900 dark:text-neutral-200">{queue.name}</h3>
          <div className="flex gap-1">
            <Button variant="ghost" size="sm" icon={<Pause className="h-3 w-3" />} onClick={() => pause.mutate(queue.name)} />
            <Button variant="ghost" size="sm" icon={<Play className="h-3 w-3" />} onClick={() => resume.mutate(queue.name)} />
          </div>
        </div>
        <div className="grid grid-cols-5 gap-2">
          {[
            { label: 'Attente', value: queue.waiting, variant: 'warning' as const },
            { label: 'Actif', value: queue.active, variant: 'info' as const },
            { label: 'OK', value: queue.completed, variant: 'success' as const },
            { label: 'Échec', value: queue.failed, variant: 'danger' as const },
            { label: 'Différé', value: queue.delayed, variant: 'neutral' as const },
          ].map((item) => (
            <div key={item.label} className="text-center">
              <Badge variant={item.variant} className="text-xs">
                {formatNumber(item.value)}
              </Badge>
              <p className="mt-1 text-[10px] text-neutral-500 dark:text-neutral-500">{item.label}</p>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
